import React from "react";

import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";

const Error = () => (
    <Container maxWidth={"md"} style={{textAlign: "center"}}>
        <br/><br/>
        <Typography variant="h4">Thank you for signing up. </Typography>
        <Typography> Please wait for admin approval before you are able to sign up for Jaydoc events. You can use
            the 'contact us' tab or send an email if you have not been approved after 1 day.</Typography>
    </Container>
);

export default Error;
